// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3N9_c";
var _4 = "disabled-2VQfr";
var _5 = "name-3qUs0";
var _6 = "name_price-2DNU5";
var _7 = "passenger-2fL94";
var _8 = "name_withPrices-3vKD2";
var _9 = "prices-Oy-J-";
var _a = "prices_rightAlign-3PwxB";
var _b = "price-3vPol";
var _c = "price__empty-3aJR_";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "disabled", _5 as "name", _6 as "name_price", _7 as "passenger", _8 as "name_withPrices", _9 as "prices", _a as "prices_rightAlign", _b as "price", _c as "price__empty" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "disabled": _4, "name": _5, "name_price": _6, "passenger": _7, "name_withPrices": _8, "prices": _9, "prices_rightAlign": _a, "price": _b, "price__empty": _c }
